import {PATH} from "./const";
import {ApiFindOptions, useApiFind} from "../../../../../../lib/HttpService";
import {StubbornSessionConfiguration} from "../../../../../../application/business/StubbornConfiguration";

export const useEditionConfigurationSessionFind = (options: ApiFindOptions = {}) => useApiFind<StubbornSessionConfiguration>(PATH, options);
